import * as Types from '../../../types/graphql.generated';

import { gql } from '@apollo/client';
import { EventFragmentDoc } from '../../fragments/generated/event.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EventsQueryVariables = Types.Exact<{
  term: Types.Scalars['String'];
  locale: Types.Scalars['String'];
  status?: Types.InputMaybe<Types.StatusTypes>;
  offset: Types.Scalars['Int'];
  sort?: Types.InputMaybe<Types.Scalars['String']>;
  limit: Types.Scalars['Int'];
  mainEvent?: Types.InputMaybe<Types.Scalars['ID']>;
}>;


export type EventsQuery = { __typename?: 'Query', events: { __typename?: 'EventPaginateResult', totalPages: number, page: number, nextPage?: number | null, prevPage?: number | null, docs: Array<{ __typename?: 'Event', id: string, name: string, description?: string | null, fullDay?: boolean | null, start?: string | null, end?: string | null, status?: Types.StatusTypes | null, locale: string, createdAt: string, updatedAt: string, image?: { __typename?: 'Media', id: string, name: string, locale: string, altText?: string | null, caption?: string | null, originalUrl: string, type: Types.MediaType, mimetype: string, createdAt: string, updatedAt: string, formats: { __typename?: 'Formats', xs: { __typename?: 'MediaFormat', url: string, width: number }, s: { __typename?: 'MediaFormat', url: string, width: number }, m: { __typename?: 'MediaFormat', url: string, width: number }, l: { __typename?: 'MediaFormat', url: string, width: number }, xl: { __typename?: 'MediaFormat', url: string, width: number } } } | null, place?: { __typename?: 'Place', id: string, name: string, status: Types.StatusTypes, locale: string, description?: string | null, createdAt: string, updatedAt: string, image?: { __typename?: 'Media', id: string, name: string, locale: string, altText?: string | null, caption?: string | null, originalUrl: string, type: Types.MediaType, mimetype: string, createdAt: string, updatedAt: string, formats: { __typename?: 'Formats', xs: { __typename?: 'MediaFormat', url: string, width: number }, s: { __typename?: 'MediaFormat', url: string, width: number }, m: { __typename?: 'MediaFormat', url: string, width: number }, l: { __typename?: 'MediaFormat', url: string, width: number }, xl: { __typename?: 'MediaFormat', url: string, width: number } } } | null, coordinates?: { __typename?: 'Coordinate', lat?: number | null, lng?: number | null, name?: string | null } | null } | null, artist?: { __typename?: 'Artist', id: string, name: string, status: Types.StatusTypes, locale: string, description?: string | null, createdAt: string, updatedAt: string, image?: { __typename?: 'Media', id: string, name: string, locale: string, altText?: string | null, caption?: string | null, originalUrl: string, type: Types.MediaType, mimetype: string, createdAt: string, updatedAt: string, formats: { __typename?: 'Formats', xs: { __typename?: 'MediaFormat', url: string, width: number }, s: { __typename?: 'MediaFormat', url: string, width: number }, m: { __typename?: 'MediaFormat', url: string, width: number }, l: { __typename?: 'MediaFormat', url: string, width: number }, xl: { __typename?: 'MediaFormat', url: string, width: number } } } | null } | null, mainEvent?: { __typename?: 'MainEvent', id: string, name: string, status: Types.StatusTypes, locale: string, description?: string | null, createdAt: string, updatedAt: string } | null, location?: { __typename?: 'Location', name?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, email?: string | null, website?: string | null, information?: string | null } | null, coordinates?: { __typename?: 'CoordinateOptional', lat?: number | null, lng?: number | null, name?: string | null } | null, form?: { __typename?: 'Form', id: string, name: string, status: Types.StatusTypes, locale: string, description: string, content: string, createdAt: string, updatedAt: string } | null }> } };


export const EventsDocument = gql`
    query Events($term: String!, $locale: String!, $status: StatusTypes, $offset: Int!, $sort: String, $limit: Int!, $mainEvent: ID) {
  events(
    term: $term
    status: $status
    locale: $locale
    sort: $sort
    limit: $limit
    offset: $offset
    mainEvent: $mainEvent
  ) {
    docs {
      ...event
    }
    totalPages
    page
    nextPage
    prevPage
  }
}
    ${EventFragmentDoc}`;

/**
 * __useEventsQuery__
 *
 * To run a query within a React component, call `useEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      locale: // value for 'locale'
 *      status: // value for 'status'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      mainEvent: // value for 'mainEvent'
 *   },
 * });
 */
export function useEventsQuery(baseOptions: Apollo.QueryHookOptions<EventsQuery, EventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
      }
export function useEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsQuery, EventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
        }
export type EventsQueryHookResult = ReturnType<typeof useEventsQuery>;
export type EventsLazyQueryHookResult = ReturnType<typeof useEventsLazyQuery>;
export type EventsQueryResult = Apollo.QueryResult<EventsQuery, EventsQueryVariables>;